import { getRequestOriginFromUrl } from 'services/utility'

// Domains
export const DOMAIN = process.env.domain || 'asda.com'
export const HTTPS = 'https://'
export const HTTP = 'http://'

const getCurrentEnv = () => {
  const location = window.location.origin;
  if(location.includes("www-dev")){
    return "development"
  } else if(location.includes("www-qa")){
    return "pqa"
  } else if(location.includes("stage")){
    return "stage"
  } else {
    return "production"
  }
}

const getAsdaUrl = () => {
  switch (getCurrentEnv()) {
    case 'production':
      return 'https://www.asda.com'
    case 'stage':
      return 'https://www-stage.asda.com'
    case 'pqa':
    case 'test':
    case 'development':
      return 'https://www-qa.asda.com'
    default:
      return 'https://www.asda.com'
  }
}

const getGroceriesUrl = () => {
  switch (getCurrentEnv()) {
    case 'production':
      return 'https://groceries.asda.com'
    case 'pqa':
    case 'test':
    case 'development':
      return 'https://groceries-qa.asda.com'
    default:
      return 'https://groceries.asda.com'
  }
}

export const GOOD_LIVING_DOMAIN = `${getAsdaUrl()}/good-living`
export const GROCERIES_DOMAIN = getGroceriesUrl()
export const GEORGE_DOMAIN = `direct.${DOMAIN}`
export const ASDA_GIFT_DOMAIN = 'asda-gifts.co.uk'
export const ASDA_STORE_LOC_DOMAIN = 'storelocator.asda.com'
export const ASDA_CUST_HELP_DOMAIN = 'asda.custhelp.com'

// URLS
export const GOOD_LIVING_SEARCH_URL = `${GOOD_LIVING_DOMAIN}/search/`
export const GROCERIES_SEARCH_URL = `${GROCERIES_DOMAIN}/search/`
export const GEORGE_SEARCH_URL = `${HTTPS}${GEORGE_DOMAIN}/on/demandware.store/Sites-ASDA-Site/default/Search-Show?q=`
export const ASDA_GIFT_SEARCH_URL = `${ASDA_GIFT_DOMAIN}/Search/Key/`
export const STORE_LOC_URL = `${HTTP}${ASDA_STORE_LOC_DOMAIN}/`
export const CUST_HELP_URL = `${HTTP}${ASDA_CUST_HELP_DOMAIN}/app/helphome`
export const GHS_URL = `${HTTPS}${document.domain &&
document.domain.replace('www', 'groceries')}`

// SEARCH redirect
export const SEARCH_REDIRECTS = '/search-redirects.json'

// CMPIDS
export const STORE_LOC_CMPID = `cmpid=ahc-_-otc-storeloc-_-asdacom-_-page-name-_-header-_-store`
export const CUST_HELP_CMPID = `cmpid=ahc-_-otc-cus-_-asdacom-_-hp-_-header-_-help`
export const P13N_MODULE_CMPID = 'cmpid=ahc-_-ghs-_-asdacom-_-hp-_-offersmodule'

// Messages
export const ERR_MSG_5XX = 'The request was made and the server responded with a status code that falls out of the range of 2xx'
export const ERR_MSG_ON_REQUEST = 'The request was made but no response was received'
export const ERR_MSG_SET_REQUEST = 'Something happened in setting up the request that triggered an Error'

export const GEORGE_URL = 'https://direct.asda.com/george'
export const DOT_COM_URL = `${HTTPS}${document.domain}`
export const REQUEST_ORIGIN = getRequestOriginFromUrl()
export const REDIRECT_URI = window.location.href
export const REGISTER_LINK = `${DOT_COM_URL}/register?request_origin=${REQUEST_ORIGIN}&redirect_uri=${encodeURIComponent(REDIRECT_URI)}`
export const BTC_REGISTER_LINK = `${DOT_COM_URL}/register-baby-club?request_origin=btc&redirect_uri=${encodeURIComponent(REDIRECT_URI)}`
export const SIGNIN_LINK = `${DOT_COM_URL}/login?request_origin=${REQUEST_ORIGIN}&redirect_uri=${encodeURIComponent(REDIRECT_URI)}&referrer=signin_btn`
export const ACCOUNT_LINK = `${DOT_COM_URL}/account?request_origin=${REQUEST_ORIGIN}&redirect_uri=${encodeURIComponent(REDIRECT_URI)}`

export const WM_CONSUMER_ID =
  window.location.host === 'www.asda.com'
    ? '44be1aee-3d2f-4bf7-96b0-0358b5f8a539'
    : 'fa1f9bc8-7b03-4c44-a063-370888dd8a4f'
export const GONE_FISHING_URL = `${GHS_URL}/asdaNS/gone_fishing.htm`
export const WAITING_PAGE_URL = `${GHS_URL}/waiting/waiting_page.htm`

// Tempo Layout Components
export const ONE_COLUMN_PAGE = 'OneColumnPage'
export const ZONES = { META: 'Meta', GUIDED_NAV: 'GuidedNav', RICH_TEXT_FOOTER: 'RichTextFooter' }
export const PAGE_CONTENT = {
  META_CONTENT: 'metaContent', SECONDARY_NAV: 'secondaryNav', FOOTER_CONTENT: 'footerContent', MAIN_CONTENT: 'mainContent',
}

// Tempo enabled pages
export const TEMPO_PHASE1_PAGES = ['help/company-details', 'toyou', 'scan-and-go', 'about']


export const DEFAULT_STORE_ID = '4959'



// WEBPACK FOOTER //
// ./services/utility/constants.js